import { useCallback, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { UserAccessRequestType } from 'entities/Users'
import { useSettingsContext } from 'pages/settings/context/settingsContext'
import { useMembersViewContext } from 'pages/settings/pages/members/pages/membersView/context/membersViewContext'
import { MembersTable } from 'pages/settings/pages/members/pages/membersView/ui/MembersTable/MembersTable'
import { getAccessRequestColumns } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui/getAccessRequestColumns'
import { getAccessRequestActions } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/ui/getAccessRequestActions'
import { requestsAccessActionConfig } from 'pages/settings/pages/members/pages/membersView/ui/RequestsMembersTab/lib/requestsAccessActionConfig'

export const InboxAccessTab = observer(() => {
  const entities = useEntitiesContext()
  const settings = useSettingsContext()
  const { fetchCounts, requestsMembersStore } = useMembersViewContext()
  const { inboxAccessStore } = requestsMembersStore
  const {
    init,
    tableStore,
    loading,
    search,
    dispose,
    setSearch,
    loadData,
    itemsRows,
    scrollToTopTrigger,
    isReviewDisabledByInboxAccess,
  } = inboxAccessStore

  const onSuccess = useCallback(() => {
    loadData()
    fetchCounts()
  }, [inboxAccessStore, fetchCounts])

  useEffect(() => {
    init()
    return dispose
  }, [])

  const columns = useMemo(() => getAccessRequestColumns(UserAccessRequestType.InboxAccess), [])

  const rows = itemsRows.map((item) => {
    item.setActionsProps({
      ...requestsAccessActionConfig,
      actions: getAccessRequestActions(item, {
        entities,
        settings,
        onSuccess,
        isReviewDisabledByInboxAccess,
      }),
    })

    return item
  })

  return (
    <MembersTable
      setSearch={setSearch}
      search={search}
      emptyStateProps={{
        text: 'No inbox access requests',
        noIcon: true,
      }}
      tableProps={{
        ariaLabel: 'InboxAccessTable',
        rows,
        columns,
        loading,
        store: tableStore,
        pinnedColumnIds: ['fullName'],
        scrollToTOpTrigger: scrollToTopTrigger,
      }}
    />
  )
})
